import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import { colors } from '../styles';

export const ContainerDrawer = withStyles({
  root: {
    borderRadius: '5px',
    border: `1px solid ${colors.gray.light}`,
    boxShadow: `2px 2px 10px ${colors.shadows.default}`,
    display: 'inline-block',
    outline: 'none',
    boxSizing: 'border-box',
  },
})(MuiPaper);
